import _asyncToGenerator from "/data/landun/workspace/vft-activities/vip-activity/pages/cny2022-sport/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/data/landun/workspace/vft-activities/vip-activity/pages/cny2022-sport/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/data/landun/workspace/vft-activities/vip-activity/pages/cny2022-sport/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/createClass.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.date.now.js";
import "core-js/modules/es.date.to-string.js";
import { rpcCGI } from '@tencent/vft-common/request';
import { request } from './request';
var baseUrl = '//vip.video.qq.com/fcgi-bin/comm_cgi';

var CommonService = /*#__PURE__*/function () {
  function CommonService() {
    _classCallCheck(this, CommonService);
  }

  _createClass(CommonService, null, [{
    key: "getUserInfo",
    value:
    /** *
     * 获取用户信息
     * @param vuid
     * @returns {*}
     */
    function getUserInfo(vuid) {
      var options = {
        name: 'spp_invite_gift_read',
        cmd: 5,
        vuid: vuid
      };
      return request({
        retry: 1
      })(baseUrl, options);
    }
    /** *
     * 获取积分
     * @returns {*}
     */

  }, {
    key: "getScore",
    value: function getScore() {
      var options = {
        name: 'get_cscore',
        type: 1
      };
      return request({
        retry: 1 // eslint-disable-next-line camelcase

      })(baseUrl, options).then(function (score) {
        return (score === null || score === void 0 ? void 0 : score.vip_score_total) || 0;
      });
    }
    /** *
     * 获取短链接
     * @param url
     * @returns {*}
     */

  }, {
    key: "getShortUrl",
    value: function getShortUrl(url) {
      var options = {
        name: 'short_url',
        need_short_url: 1,
        is_share: 1,
        margin: 1,
        url: url
      };
      return request({
        retry: 2
      })(baseUrl, options).then(function (res) {
        return res.short_url;
      });
    }
    /**
     * 生成口令
     * @param {String} url 目标链接
     * @param {String} pageId 页面Id
     */

  }, {
    key: "getPassword",
    value: function getPassword(url, pageId) {
      var options = {
        name: 'spp_magic_activity_kouling',
        cmd: 1,
        pageid: pageId,
        jumpurl: url
      };
      return request({
        retry: 2
      })(baseUrl, options).then(function (res) {
        return res.cmdid;
      });
    }
    /**
     * 获取绑定的手机号
     * @returns {*}
     */

  }, {
    key: "getBindPhone",
    value: function getBindPhone() {
      var options = {
        name: 'bindphone',
        cmd: 16,
        _t: 5
      };
      return request({})(baseUrl, options);
    }
    /** *
     * 邀请有礼
     * @returns {*}
     */

  }, {
    key: "inviteOpenVip",
    value: function inviteOpenVip() {
      var options = {
        name: 'invite_createpackage',
        cmd: 4353,
        actid: 'HLW_9544AR'
      };
      return request()(baseUrl, options);
    }
    /** *
     * 京东账号检查
     * @returns {*}
     */

  }, {
    key: "jdOpenCheck",
    value: function jdOpenCheck() {
      var options = {
        name: 'spp_vip_plus_jd',
        cmd: 63188
      };
      return request()(baseUrl, options);
    }
    /** *
     * 获取服务器时间
     * @returns ms
     */

  }, {
    key: "getServerTime",
    value: function () {
      var _getServerTime = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return rpcCGI('trpc.ffgn_plat_group.get_conf.Timer/GetCurrentTime');

              case 3:
                res = _context.sent;

                if (!(!res || !res.ts)) {
                  _context.next = 7;
                  break;
                }

                console.error('获取服务器时间失败', res);
                return _context.abrupt("return", Date.now());

              case 7:
                return _context.abrupt("return", res.ts * 1000);

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](0);
                console.error('获取服务器时间失败', _context.t0);
                return _context.abrupt("return", Date.now());

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 10]]);
      }));

      function getServerTime() {
        return _getServerTime.apply(this, arguments);
      }

      return getServerTime;
    }()
  }]);

  return CommonService;
}();

export default CommonService;